import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0bbd2bbd"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = {
  class: "time"
};
const _hoisted_4 = {
  class: "bottom"
};
const _hoisted_5 = {
  class: "item"
};
const _hoisted_6 = {
  class: "icon"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "name"
};
const _hoisted_9 = {
  class: "value"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.nowTime), 1), _createVNode(_component_el_select, {
    modelValue: $data.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.value = $event),
    class: "m-2",
    placeholder: "请选择大棚",
    size: "large",
    onChange: $options.selectChange
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.plotList, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: item.id,
        label: item.name,
        value: item.id,
        onClick: $event => $options.optionClick(item)
      }, null, 8, ["label", "value", "onClick"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"])]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.itemList, item => {
    return _openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
      src: item.icon,
      alt: ""
    }, null, 8, _hoisted_7)]), _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(item.value), 1)]);
  }), 256))])]);
}